import { sdkContextStatus } from "src/context/SDKContext"
import { useQuery } from "react-query"
import { RoomValidationResult } from "src/context/types"
import axios from "src/shared/axios"
import { InspirationModel } from "src/components/views/avatars/components/Inspirations"

const QUERY_KEY = "inspirations"

type Args = {
  filterByCategoryId?: number
  filterByTag?: string
}

export function useInspirations({
  filterByCategoryId,
  filterByTag
}: Args = {}) {
  const { data } = useQuery({
    queryKey: [QUERY_KEY],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const meetingClient = await sdkContextStatus
      const url = new URL(meetingClient?.envConfig.INSPIRATIONS_URL)
      url.searchParams.append("host", meetingClient?.envConfig.DOMAIN_HOSTNAME)
      try {
        const response = await axios.get<{ inspirations: InspirationModel[] }>(
          url.toString()
        )
        return response.data
      } catch (err) {
        console.error(err)
        throw err
      }
    }
  })

  const inspirations = data?.inspirations
    ?.sort((a, b) => a.position - b.position)
    .filter((inspiration: InspirationModel) => {
      const passesCategoryIdFilter = filterByCategoryId
        ? inspiration.categoryIds?.includes(filterByCategoryId)
        : true

      const passesTagFilter = !!filterByTag
        ? inspiration.tag
            ?.toLocaleLowerCase()
            .includes(filterByTag.toLowerCase())
        : true
      return passesCategoryIdFilter && passesTagFilter
    })
  return { inspirations }
}
